import React, { useRef } from "react";
import { useEffect, useState } from "react";
import { NavDropdown, Tab, Tabs } from "react-bootstrap";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import {
  // notificationResponse,
  notificationData,
  // notificationClear,
  notificationSingleData,
  // notificationSingleResponse,
  notificationSingleClear,
  notificationAllReadData,
  // notificationAllReadResponse,
  // notificationAllReadClear,
  notificationCountData,
  notificationAllData,
  // notificationCountResponse,
  // notificationCountClear,
} from "../redux/notification/actions";
import { clickStreamUser, redirectToPageUtil, SessionKeys, timezoneArea } from "../utils/AppUtils";
import { useNavigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";

// import CONFIG from "../utils/config";
import moment from "moment";
import ShimmerNotification from "./Layouts/ShimmerNotification";
import { LegendToggleTwoTone } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

const Notification = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const notificationResData = useSelector(
    (state) => state?.notification?.notificationData
  );

  const notificationSingleResData = useSelector(
    (state) => state?.notification?.notificationSingleData
  );
  const notificationReadAllResData = useSelector(
    (state) => state?.notification?.notificationAllData
  );
  const notificationAllReadResData = useSelector(
    (state) => state?.notification?.notificationAllReadData
  );
  const notificationCountResult = useSelector(
    (state) => state?.notification?.notificationCountData
  );
  const blinkNotification = useSelector(
    (state) => state.home.blinkNotification
  );

  // console.log("Count notificationss", notificationCountResult);
  const authBroker = useSelector((state) => state.auth.authBroker);
  const auth = useSelector((state) => state.auth);
  const userDetailRes = useSelector((state) => state.user.userBroker);

  const [notification, setNotification] = useState([]);
  const [showUnRead, setShowUnRead] = useState(false);
  // const [showResults, setShowResults] = useState(true);
  const [notificationCount, setNotificationCount] = useState(0);
  const [id, setId] = useState(null);
  const [imgLoader, setImgLoader] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [showNotificationPulse, setShowNotificationPulse] = useState(
    localStorage.getItem(SessionKeys.NOTI_SHOW) === "true" ? true : false
  );
  const [timezone, setTimezone] = useState("");
  const [clickedShowUnread, setClickedShowUnread] = useState(true);
  const [isAllRead, setIsAllRead] = useState(false);
  const [activeTab, setActiveTab] = useState("unread");
  const [shimmerLoading, setShimmerLoading] = useState(false);
  const [courseData, setCourseData] = useState({});

  useEffect(() => {
    // console.log("userDetailRes: ", userDetailRes);
    if (!_.isEmpty(userDetailRes?.payload?.payload)) {
      const timeZone = userDetailRes.payload.payload.timezone
        ? userDetailRes.payload.payload.timezone.replace(":", "")
        : "-0500";
      setTimezone(timeZone);
    }
  }, [userDetailRes]);

  let allNotifications;
  const [loadMore, setloadMore] = useState(false);
  const [totalNotificationCount, setTotalNotificationCount] = useState();
  const [VisibleNotificationsCount, setVisibleNotificationsCount] = useState();
  useEffect(() => {
    if (!_.isEmpty(notificationResData)) {
      setImgLoader(false);
      setShimmerLoading(false);
      if (notificationResData?.status === "success") {
        let isReadAll = true;
        let datas = notificationResData?.payload?.payload?.dataList;
        setTotalNotificationCount(
          notificationResData?.payload?.payload?.total_notification
        );
        allNotifications = [...notification, ...datas];
        const uniqueArray = _.uniqBy(allNotifications, "id");
        setVisibleNotificationsCount(uniqueArray.length);
        for (const item of datas) {
          if (item.status === "unread") {
            isReadAll = false;
          }
        }
        setIsAllRead(isReadAll);
        setNotification(uniqueArray);
      }
      setIsLoading(false);
      // dispatch(notificationClear());
    }
  }, [notificationResData]);

  useEffect(() => {
    if (!_.isEmpty(notificationCountResult)) {
      setImgLoader(false);
      console.log("check--", notificationCountResult);
      if (notificationCountResult?.status === "success") {
        const count = notificationCountResult?.payload?.payload?.unread_count;
        if (count > notificationCount) {
          localStorage.setItem(SessionKeys.NOTI_SHOW, true);
          setShowNotificationPulse(true);
        }
        setNotificationCount(count);
      }
    }
  }, [notificationCountResult]);

  useEffect(() => {
    if (!_.isEmpty(notificationSingleResData)) {
      if (notificationSingleResData?.status === "success") {
        // console.log(notificationSingleResData);
        const notificationDataSingle =
          notificationSingleResData.payload.payload.dataList;
        if (!_.isEmpty(notificationDataSingle)) {
          setNotification(notificationDataSingle);
          for (let n of notificationDataSingle) {
            if (n.id === id) {
              goToNotification(n.redirection_key, n.id, n.redirection_value, n);
            }
          }
          onClickOfAllTab();
        }
        dispatch(notificationSingleClear());
      }
    }
  }, [notificationSingleResData]);

  useEffect(() => {
    getNotificationCount();
  }, [dispatch]);

  useEffect(() => {
    if (isOpen) {
      setShowUnRead(false);
      setActiveTab("unread"); //all to unread
      // getNotificationList(); // changed to unread API
      getNotificationAllUnread();
      if (showNotificationPulse) {
        localStorage.setItem(SessionKeys.NOTI_SHOW, false);
        setShowNotificationPulse(false);
      }
    }
  }, [isOpen]);
  //let counter=1;

  const [counter, setCounter] = useState(0);
  const [alltabClick, setalltabClick] = useState(false);
  const getNotificationList = (isClick = false) => {
    console.log("alltab", alltabClick);
    var limit = 0;
    isClick ? (limit = 0) : (limit = Math.floor(notification.length / 10));
    console.log("lenght in api", notification.length);
    console.log("limit--", limit);
    setShimmerLoading(true);
    dispatch(
      notificationData({
        module: "myNotification",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          offset: limit + 1,
        },
      })
    );
    setalltabClick(false);
  };
  useEffect(() => {}, [counter]);
  // const handleLoadMore =()=>{
  //     setCounter((counter)=>counter+1);
  // }
  const onClickOfAllTab = () => {
    setCounter(0);
    setNotification([]);
    setalltabClick(true);
    getNotificationList(true);
  };

  const markAsRead = (id) => {
    setId(id);
    dispatch(
      notificationSingleData({
        module: "myNotification",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          status: "read",
          id: [id],
        },
      })
    );
  };

  const markAllAsRead = () => {
    let idArr = [];
    for (let i = 0; i < notification.length; i++) {
      const element = notification[i];
      if (element.status !== "read") {
        idArr.push(element.id);
      }
    }
    dispatch(
      notificationAllData({
        module: "myNotification",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          status: "read",
          id: [],
        },
      })
    );
  };
  useEffect(() => {
    if (!_.isEmpty(notificationReadAllResData)) {
      if (notificationReadAllResData?.status === "success") {
        // console.log(notificationSingleResData);
        setIsLoading(true);
        console.log("activTab: ", activeTab);
        setActiveTab("unread"); //all to unread
        onClickOfUnreadTab();
      }
    }
  }, [notificationReadAllResData]);

  const getNotificationAllRead = () => {
    dispatch(
      notificationAllReadData({
        module: "myNotification",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          status: "read",
        },
      })
    );
  };

  // let unreadCounter=1;
  const [unreadCounter, setunreadCounter] = useState(0);
  const getNotificationAllUnread = (click = false) => {
    setShimmerLoading(true);
    var limit = 0;
    click ? (limit = 0) : (limit = Math.floor(notification.length / 10));
    dispatch(
      notificationData({
        module: "myNotification",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          status: "unread",
          offset: limit + 1,
        },
      })
    );
  };
  useEffect(() => {}, [unreadCounter]);

  // const unreadLoadMoreHandler =()=>{
  //   setunreadCounter((unreadCounter)=>unreadCounter+1);
  // }

  const onClickOfUnreadTab = () => {
    setNotification([]);
    setClickedShowUnread(true);
    setunreadCounter(1);
    getNotificationAllUnread(true);
  };

  const getNotificationCount = () => {
    setTimeout(() => {
      dispatch(
        notificationCountData({
          module: "myNotificationCount",
          postData: {
            token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          },
        })
      );
    }, 4000);
  };

  const goToNotification = (keyword, id, redirection_value, item) => {

    if(item?.entity_status === "0"){
      return;
    }

    if(item?.notification_type?.toLowerCase()?.includes("course")){
      if(window.location.href?.includes("courseDetail")){
        navigate("/home")
      }
      let obj  = {
  source: "broker",
  id: item?.cid,
  is_paid: true,
  from: "course",
  provider_id: null,
  provider_name: null,
  cname: null,
  status: "not-started",
  product_type: "course",
  crscd: item?.code,
  is_onboarding: "0",
};
redirectToPageUtil(
                  obj,
                  navigate,
                  authBroker,
                  setCourseData,
                  dispatch,
                  "course"
                )
    }else {
      switch (keyword) {
      case "administrator-dashboard":
        if (!_.isEmpty(redirection_value)) {
          navigate(redirection_value); //navigate("/role-play");
        }
        break;
      case "request-role":
        navigate("/accept-role");
        // console.log("Id clicked", id);
        clickStreamUser("role_requests_menu_click", {
          userId: auth.authBroker?.payload?.user.user_id,
        });
        break;
      case "home":
        navigate("/home");
        // console.log("Id clicked", id);
        clickStreamUser("role_requests_menu_click", {
          userId: auth.authBroker?.payload?.user.user_id,
        });
        break;
      
      case "profile":
        navigate(
          "/profile/edit?section=edit&tab=1&user_id=" +
            auth.authBroker?.payload?.user.user_id
        );
        // console.log("Id clicked", id);
        clickStreamUser("role_requests_menu_click", {
          userId: auth.authBroker?.payload?.user.user_id,
        });
        break;
      case "course-listing":
        if (!_.isEmpty(redirection_value)) {
          navigate(redirection_value);
        }
        // console.log("Id clicked", id);
        clickStreamUser("my_course_menu_click", {
          userId: auth.authBroker?.payload?.user.user_id,
        });
        break;
      case "learning path":
        if (!_.isEmpty(redirection_value)) {
          navigate(redirection_value); //navigate("/learn/learningpath");
        }
        // console.log("Id clicked", id);
        clickStreamUser("learning_paths_menu_click", {
          userId: auth.authBroker?.payload?.user.user_id,
        });
        break;
      case "onboarding-path":
        // navigate("/my-onboarding");
        navigate(redirection_value);
        // console.log("Id clicked", id);
        clickStreamUser("my_onboarding_menu_click", {
          userId: auth.authBroker?.payload?.user.user_id,
        });
        break;
      case "course":
        navigate("/my-courses");
        // console.log("Id clicked", id);
        clickStreamUser("learning_paths_menu_click", {
          userId: auth.authBroker?.payload?.user.user_id,
        });
        break;
      case "codeOfEthics":
        navigate("/codeOfEthics");
      case "reschedule_request":
        navigate("/booking-requests");
      default:
         if (!_.isEmpty(redirection_value)) {
          navigate(redirection_value);
        }
        break;
      }
    }
  };
  //setKeyword(payload.data);
  var NinetyNine = "99+";

  const containerRef = useRef(null);

  const [loader, setloader] = useState(false);
  const handleScroll = () => {
    setloader(true);
    const container = containerRef.current;

    if (container) {
      const { scrollTop, scrollHeight, clientHeight } = container;

      if (scrollHeight - clientHeight - 1 <= scrollTop) {
        if (VisibleNotificationsCount < totalNotificationCount) {
          getNotificationList();
        } else {
          setloader(false);
        }
      }
    }
  };

  const unreadcontainerRef = useRef(null);
  const handleScrollUnread = () => {
    setloader(true);
    const container = unreadcontainerRef.current;
    if (container) {
      const { scrollTop, scrollHeight, clientHeight } = container;
      if (scrollHeight - clientHeight - 1 <= scrollTop) {
        setClickedShowUnread(false);
        if (VisibleNotificationsCount < totalNotificationCount) {
          getNotificationAllUnread();
        } else {
          setloader(false);
        }
      }
    }
  };

  return (
    <>
      <div className="nav-item dropdown notifydroprsp" id="myCheck">
        {showNotificationPulse === true ? (
          <span className={notificationCount === 0 ? "" : "noticount"}>
            {/* {notificationCount > 99
            ? `${NinetyNine}`
            : notificationCount > 0
            ? notificationCount
            : ""} */}
          </span>
        ) : (
          ""
        )}

        <NavDropdown
          onToggle={() => {
            setIsOpen(!isOpen);
            setalltabClick(true);
            setNotification([]);
          }}
          className="notification-nav"
          title={
            <span className="iconno" title={t("Notification")}>
              <svg width="16" height="16" viewBox="0 0 16 16" onClick={() => {
                  clickStreamUser("notifications-button-clicked", {
                    userId: authBroker?.payload?.user.user_id,
                  });
                }} fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16 10.7681V13.5041H0V10.7681L1.792 9.9521L3.36 4.91209C3.488 4.49609 3.728 4.16009 4.08 3.90409C4.432 3.63743 4.82667 3.50409 5.264 3.50409H10.736C11.1733 3.50409 11.568 3.63743 11.92 3.90409C12.272 4.16009 12.512 4.49609 12.64 4.91209L14.208 9.9521L16 10.7681ZM15.008 12.4961V11.4081L13.376 10.6721L13.248 10.2401L11.68 5.20009C11.616 4.98676 11.4933 4.81609 11.312 4.68809C11.1413 4.56009 10.9493 4.49609 10.736 4.49609H5.28C5.056 4.49609 4.85333 4.56009 4.672 4.68809C4.50133 4.81609 4.384 4.98676 4.32 5.20009L2.752 10.2401L2.624 10.6721L1.008 11.4081V12.4961H15.008ZM10.848 14.4961C10.4747 14.8161 10.0587 15.0614 9.6 15.2321C9.152 15.4134 8.67733 15.5041 8.176 15.5041C7.67467 15.5041 7.19467 15.4134 6.736 15.2321C6.288 15.0614 5.87733 14.8161 5.504 14.4961H10.848ZM5.504 2.99209C5.504 2.54409 5.616 2.12809 5.84 1.74409C6.064 1.36009 6.368 1.05609 6.752 0.832094C7.136 0.608094 7.552 0.496094 8 0.496094C8.448 0.496094 8.864 0.608094 9.248 0.832094C9.632 1.05609 9.936 1.36009 10.16 1.74409C10.384 2.12809 10.496 2.54409 10.496 2.99209H9.504C9.504 2.58676 9.35467 2.24009 9.056 1.95209C8.768 1.65343 8.416 1.50409 8 1.50409C7.584 1.50409 7.22667 1.65343 6.928 1.95209C6.64 2.24009 6.496 2.58676 6.496 2.99209H5.504Z" fill="#474747"/>
              </svg>

              {blinkNotification && <span className="noticount"></span>}
            </span>
          }
        >
          {isLoading ? (
            [1, 2].map((m) => {
              return <ShimmerNotification key={`notify-${m}-shimmer`} />;
            })
          ) : (
            <>
              <div className="rows my_learningpath_tab">
                <Tabs
                  onSelect={(k) => {
                    setActiveTab(k);
                    if (k === "all") {
                      onClickOfAllTab();
                    } else {
                      onClickOfUnreadTab();
                    }
                  }}
                  activeKey={activeTab}
                  defaultActiveKey="unread"
                  className="containe-notify"
                >
                  <Tab eventKey="unread" title={t("Unread")}>
                    {notification.length === 0 && shimmerLoading ? (
                      [1, 2].map((m) => {
                        return (
                          <ShimmerNotification key={`notify-${m}-shimmer`} />
                        );
                      })
                    ) : notification.length > 0 ? (
                      <div
                        className="scroll-nofify"
                        ref={unreadcontainerRef}
                        onScroll={() => handleScrollUnread()}
                      >
                        {notification.map((item, i) => {
                          return (
                            <>
                              <NavDropdown.Item
                                key={`notify-${i + 1}`}
                                className="get_CertifiedContainer dropdownItem_notiFcation"
                              >
                                <div className="getCertified">
                                  <a href="#"> </a>
                                </div>
                                <div
                                  className="getCertified_content"
                                  onClick={() =>
                                    item.status === "read"
                                      ? goToNotification(
                                          item.redirection_key,
                                          item.id,
                                          item?.redirection_value,
                                          item
                                        )
                                      : markAsRead(item.id)
                                  }
                                >
                                  <h6
                                    className={`${
                                      item.status === "read" ? "hide-bold" : ""
                                    }`}
                                  >
                                    {item?.notification_content}
                                  </h6>
                                  <p className="text-right">
                                    {timezone
                                      ? moment
                                          .utc(
                                            item.created_at,
                                            "YYYY-MM-DD hh:mm:ss"
                                          )
                                          .tz(timezoneArea(timezone))
                                          .fromNow()
                                      : moment
                                          .utc(
                                            item.created_at,
                                            "YYYY-MM-DD hh:mm:ss"
                                          )
                                          .tz(timezoneArea("-0500"))
                                          .fromNow()}
                                  </p>
                                </div>
                              </NavDropdown.Item>
                            </>
                          );
                        })}
                        {loader ? (
                          [1, 2].map((m) => {
                            return (
                              <ShimmerNotification
                                key={`notify-${m}-shimmer`}
                              />
                            );
                          })
                        ) : (
                          <></>
                        )}
                      </div>
                    ) : (
                      <p className="no-notifation text-center p-3">
                        <span className="notrico d-block mb-3">
                         <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M48 32.3043V40.5123H0V32.3043L5.376 29.8563L10.08 14.7363C10.464 13.4883 11.184 12.4803 12.24 11.7123C13.296 10.9123 14.48 10.5123 15.792 10.5123H32.208C33.52 10.5123 34.704 10.9123 35.76 11.7123C36.816 12.4803 37.536 13.4883 37.92 14.7363L42.624 29.8563L48 32.3043ZM45.024 37.4883V34.2243L40.128 32.0163L39.744 30.7203L35.04 15.6003C34.848 14.9603 34.48 14.4483 33.936 14.0643C33.424 13.6803 32.848 13.4883 32.208 13.4883H15.84C15.168 13.4883 14.56 13.6803 14.016 14.0643C13.504 14.4483 13.152 14.9603 12.96 15.6003L8.256 30.7203L7.872 32.0163L3.024 34.2243V37.4883H45.024ZM32.544 43.4883C31.424 44.4483 30.176 45.1843 28.8 45.6963C27.456 46.2403 26.032 46.5123 24.528 46.5123C23.024 46.5123 21.584 46.2403 20.208 45.6963C18.864 45.1843 17.632 44.4483 16.512 43.4883H32.544ZM16.512 8.97628C16.512 7.63228 16.848 6.38428 17.52 5.23228C18.192 4.08028 19.104 3.16828 20.256 2.49628C21.408 1.82428 22.656 1.48828 24 1.48828C25.344 1.48828 26.592 1.82428 27.744 2.49628C28.896 3.16828 29.808 4.08028 30.48 5.23228C31.152 6.38428 31.488 7.63228 31.488 8.97628H28.512C28.512 7.76028 28.064 6.72028 27.168 5.85628C26.304 4.96028 25.248 4.51228 24 4.51228C22.752 4.51228 21.68 4.96028 20.784 5.85628C19.92 6.72028 19.488 7.76028 19.488 8.97628H16.512Z" fill="#415385"/>
                          </svg>
                        </span>
                        {!clickedShowUnread && notification?.length === 0
                          ? "Yet to receive notifications."
                          : "We will let you know when we get news for you."}
                      </p>
                    )}
                  </Tab>
                  <Tab eventKey="all" title={t("All")}>
                    {notification.length === 0 && shimmerLoading ? (
                      [1, 2].map((m) => {
                        return (
                          <ShimmerNotification key={`notify-${m}-shimmer`} />
                        );
                      })
                    ) : notification.length > 0 ? (
                      <>
                        <div
                          className="scroll-nofify"
                          ref={containerRef}
                          onScroll={() => handleScroll()}
                        >
                          {notification.map((item, i) => {
                            return (
                              <>
                                <NavDropdown.Item
                                  id={`notify-${i + 1}`}
                                  key={`notify-${i + 1}`}
                                  className="get_CertifiedContainer dropdownItem_notiFcation"
                                >
                                  <div className="getCertified">
                                    <a href="#"> </a>
                                  </div>
                                  <div
                                    className="getCertified_content"
                                    onClick={() =>
                                      item.status === "read"
                                        ? goToNotification(
                                            item.redirection_key,
                                            item.id,
                                            item?.redirection_value,
                                            item
                                          )
                                        : markAsRead(item.id)
                                    }
                                  >
                                    <h6
                                      className={`${
                                        item.status === "read"
                                          ? "hide-bold"
                                          : ""
                                      }`}
                                    >
                                      {item?.notification_content}
                                    </h6>
                                    <p className="text-right">
                                      {timezone
                                        ? moment
                                            .utc(
                                              item.created_at,
                                              "YYYY-MM-DD hh:mm:ss"
                                            )
                                            .tz(timezoneArea(timezone))
                                            .fromNow()
                                        : moment
                                            .utc(
                                              item.created_at,
                                              "YYYY-MM-DD hh:mm:ss"
                                            )
                                            .tz(timezoneArea("-0500"))
                                            .fromNow()}
                                    </p>
                                  </div>
                                </NavDropdown.Item>
                              </>
                            );
                          })}
                          {loader ? (
                            [1, 2].map((m) => {
                              return (
                                <ShimmerNotification
                                  key={`notify-${m}-shimmer`}
                                />
                              );
                            })
                          ) : (
                            <></>
                          )}
                        </div>
                        
                      </>
                    ) : (
                         <p className="no-notifation text-center p-3">
                        <span className="notrico d-block mb-3">
                         <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M48 32.3043V40.5123H0V32.3043L5.376 29.8563L10.08 14.7363C10.464 13.4883 11.184 12.4803 12.24 11.7123C13.296 10.9123 14.48 10.5123 15.792 10.5123H32.208C33.52 10.5123 34.704 10.9123 35.76 11.7123C36.816 12.4803 37.536 13.4883 37.92 14.7363L42.624 29.8563L48 32.3043ZM45.024 37.4883V34.2243L40.128 32.0163L39.744 30.7203L35.04 15.6003C34.848 14.9603 34.48 14.4483 33.936 14.0643C33.424 13.6803 32.848 13.4883 32.208 13.4883H15.84C15.168 13.4883 14.56 13.6803 14.016 14.0643C13.504 14.4483 13.152 14.9603 12.96 15.6003L8.256 30.7203L7.872 32.0163L3.024 34.2243V37.4883H45.024ZM32.544 43.4883C31.424 44.4483 30.176 45.1843 28.8 45.6963C27.456 46.2403 26.032 46.5123 24.528 46.5123C23.024 46.5123 21.584 46.2403 20.208 45.6963C18.864 45.1843 17.632 44.4483 16.512 43.4883H32.544ZM16.512 8.97628C16.512 7.63228 16.848 6.38428 17.52 5.23228C18.192 4.08028 19.104 3.16828 20.256 2.49628C21.408 1.82428 22.656 1.48828 24 1.48828C25.344 1.48828 26.592 1.82428 27.744 2.49628C28.896 3.16828 29.808 4.08028 30.48 5.23228C31.152 6.38428 31.488 7.63228 31.488 8.97628H28.512C28.512 7.76028 28.064 6.72028 27.168 5.85628C26.304 4.96028 25.248 4.51228 24 4.51228C22.752 4.51228 21.68 4.96028 20.784 5.85628C19.92 6.72028 19.488 7.76028 19.488 8.97628H16.512Z" fill="#415385"/>
                          </svg>
                        </span>
                        {!clickedShowUnread && notification?.length === 0
                          ? "Yet to receive notifications."
                          : "We will let you know when we get news for you."}
                      </p>
                    )}
                  </Tab>
                </Tabs>
              </div>
              {!clickedShowUnread && notification?.length === 0 ? (
                ""
              ) : (
                <div className="getCertified buutndf">
                  {false && (
                    <button
                      type="button"
                      className="btn btn-primary btn-block setup-button markAll_btn"
                      onClick={() => {
                        setImgLoader(true);
                        setClickedShowUnread(true);
                        showUnRead
                          ? getNotificationList()
                          : getNotificationAllUnread();
                        setShowUnRead(!showUnRead);
                      }}
                    >
                      {imgLoader ? (
                        <div className="d-flex justify-content-center w-100">
                          <Spinner animation="border" />
                        </div>
                      ) : showUnRead ? (
                        "Show all"
                      ) : (
                        "Show unread only"
                      )}
                    </button>
                  )}
                  <button
                    className="getNotFieedbutton btn-primary"
                    onClick={() => {
                      markAllAsRead();
                    }}
                  >
                    {t("Mark all as read")}
                  </button>
                  <button
                    className="getNotFieedbutton btn-primary"
                    onClick={() => {
                      document.getElementById("myCheck").click();
                      setCounter(0);
                      setNotification([]);
                    }}
                  >
                    {t("Close")}
                  </button>
                </div>
              )}
            </>
          )}
        </NavDropdown>
      </div>
    </>
  );
};

export default Notification;
